import { create } from "zustand";

export const useVendor = create((set, get)=>({
    regions: [],
    setRegions: (regions) => set({ regions }),
    districts: [],
    setDistricts: (districts) => set({ districts }),
    mybusiness: null,
    setMyBusiness: (mybusiness) => set({ mybusiness }),
    mainImage: null,
    setMainImage: (mainImage) => set({ mainImage }),
    st: [],
    setSt: (st) => set({ st }),
    // Yangi xizmat yaratilgandan keyin ID saqlash (tablar orasida ishlatiladi)
    currentServiceId: null,
    setCurrentServiceId: (id) => set({ currentServiceId: id }),
}))